
export default {
  props: {
    post: {
      type: Object,
      default: null
    }
  },
  computed: {
    itemImage() {
      return {
        src: this.post.image.src,
        ratio: '4/3',
        fit: 'cover',
        lazy: true
      }
    },
    itemLink() {
      const route = {
        name: 'posts-id',
        params: { id: this.post.slug }
      }

      return this.$pagePath(route)
    }
  }
}
